import React, { createContext, useContext, useReducer } from 'react';
import { pncpPurchaseContractDetailReducer, initialState, IPncpPurchaseContractDetailState, Action } from './pncp-purchase-contract-detail-reducer';

const PncpPurchaseContractDetailStateContext = createContext<IPncpPurchaseContractDetailState | undefined>(undefined);
const PncpPurchaseContractDetailDispatchContext = createContext<React.Dispatch<Action> | undefined>(undefined);

export const PncpPurchaseContractDetailProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [state, dispatch] = useReducer(pncpPurchaseContractDetailReducer, initialState);

    return (
        <PncpPurchaseContractDetailStateContext.Provider value={state}>
            <PncpPurchaseContractDetailDispatchContext.Provider value={dispatch}>
                {children}
            </PncpPurchaseContractDetailDispatchContext.Provider>
        </PncpPurchaseContractDetailStateContext.Provider>
    );
};

export const usePncpPurchaseContractDetailState = (): IPncpPurchaseContractDetailState => {
    const context = useContext(PncpPurchaseContractDetailStateContext);
    if (!context) {
        throw new Error('usePncpPurchaseContractDetailState must be used within PncpPurchaseContractDetailProvider');
    }
    return context;
};

export const usePncpPurchaseContractDetailDispatch = (): React.Dispatch<Action> => {
    const context = useContext(PncpPurchaseContractDetailDispatchContext);
    if (!context) {
        throw new Error('usePncpPurchaseContractDetailDispatch must be used within PncpPurchaseContractDetailProvider');
    }
    return context;
};
